/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { INotificationsListViewProps } from './notifications-list';

export const NotificationsListView: React.FC<INotificationsListViewProps> = props => {
    return <Module {...props.container}>{props.notificationsList}</Module>;
};

export default NotificationsListView;
